{
  "p": { "buildable": true, "interior": [8, 8] },
  "b": { "buildable": true },
  "a": { "buildable": true },
  "h": { "buildable": true, "resource": { "item": "iron_ore", "rate": 30 } },
  "c": { "buildable": true },
  "m": { "buildable": true },
  "t": { "buildable": true },
  "l": { "buildable": false },
  "r": { "buildable": false }
}
